export default {
  title: 'Users',
  subtitle: 'List of Users',
  create: 'Add a User'
}
